import { render } from "./DepositNotFoundComponent.vue?vue&type=template&id=d82102b0&ts=true"
import script from "./DepositNotFoundComponent.vue?vue&type=script&lang=ts"
export * from "./DepositNotFoundComponent.vue?vue&type=script&lang=ts"

import "./DepositNotFoundComponent.vue?vue&type=style&index=0&id=d82102b0&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/buyCrypto/DepositNotFoundComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d82102b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d82102b0', __exports__)) {
    api.reload('d82102b0', __exports__)
  }
  
  module.hot.accept("./DepositNotFoundComponent.vue?vue&type=template&id=d82102b0&ts=true", () => {
    api.rerender('d82102b0', render)
  })

}


export default __exports__